<div class="offer-card-wrap" [lxResponsiveClass]="cardResponsiveClass">
  @if (offer; as offer) {
    <div
      class="offer-card"
      data-theme-key="--bg-card"
      [class.offer-card--tiles]="viewMode === 'tiles'"
      [class.offer-card--list]="viewMode === 'list'"
      [class.expanded]="isExpanded">
      <ui-new-offer-image
        [offer]="offer"
        [index]="index"
        [propertyId]="propertyId"
        [offerAliasId]="offerAliasId"
        [viewMode]="viewMode">
      </ui-new-offer-image>
      <div class="offer-body">
        <div class="offer-head">
          <div
            class="offer-title-wrap"
            (mouseenter)="openTitlePopover()"
            (mouseleave)="closeTitlePopover()">
            <button
              type="button"
              class="offer-title offer-title-trigger"
              data-theme-key="--text-main"
              [attr.aria-expanded]="titlePopoverOpen"
              aria-haspopup="dialog"
              [attr.aria-label]="offerTitle"
              (click)="toggleTitlePopover($event)"
              (focus)="openTitlePopover()"
              (blur)="closeTitlePopover()">
              {{ offer.amenities.upsell_room_name | titlecase }}
            </button>

            @if (titlePopoverOpen && offerTitle) {
              <div class="offer-title-popover" role="tooltip">
                {{ offer.amenities.upsell_room_name | titlecase }}
              </div>
            }
          </div>


          @if (offer.flg_default_offer) {
            <span class="material-icons icon-featured" data-theme-key="--accent" aria-hidden="true">auto_awesome</span>
          }

          <button
            class="favorite-btn"
            type="button"
            data-favorite-toggle
            [attr.data-offer-id]="offer.offer_id"
            [class.active]="!!offer.flg_favorite"
            (click)="toggleFavorite($event)"
            aria-label="Favorite">
            <span class="material-icons">{{ offer.flg_favorite ? 'favorite' : 'favorite_border' }}</span>
          </button>

        </div>
        <div class="offer-meta-row">
          <div class="offer-price" data-theme-key="--text-main">
            @if (shouldShowStrike(offer)) {
              <span class="price-strike" data-theme-key="--text-muted">
                {{ offer.bar_price | currency : 'USD' : 'symbol' : '1.0-0' }}
              </span>
            }
            <span class="price-main">
              {{ offer.ofr_price | currency : 'USD' : 'symbol' : '1.2-2' }}
            </span>
            <span data-theme-key="--text-muted" class="price-suffix">Per Night Extra</span>
          </div>
          <ui-new-offer-icon data-theme-key="--pill-bg --pill-text" [offer]="offer" [viewMode]="viewMode"></ui-new-offer-icon>
        </div>
        <ui-new-offer-content
          [offers]="offers"
          [offer]="offer"
          [index]="index"
          [viewMoreToggle]="viewMoreToggle"
          [offerAliasId]="offerAliasId"
          [propertyId]="propertyId"
          [viewMode]="viewMode">
        </ui-new-offer-content>
      </div>
    </div>
  }
</div>
